<template>
  <div>
    <el-alert title="此为临时链接，仅用于预览，将在短期内失效。" center :closable="false" type="warning"></el-alert>
    <div v-if="data" class="article-info  ql-snow ">
      <h1 class="m-b-20">{{ data.title }}</h1>
      <div class=" ratio ratio-16x9" v-if="data.video_id && data.video && data.video.src">
        <video controls="controls"  :poster="data.poster[0]" class="video-poster bg-black h-100">
          <source :src="data.video.src" />
        </video>
      </div>
      
      <article class="content ql-editor" v-html="data.content"></article>

      <div class=" w-100 d-flex border p-3 rounded position-relative cursor-pointer" v-if="rv_info">
        <div class=" width-100">
          <img class=" w-100" :src="rv_info.poster + '?x-oss-process=style/16x9'" alt="">
        </div>
        <div class=" ms-2" style="flex:1;">
          <div>{{ rv_info.name }}</div>
          <div class=" text-muted">
              <span>{{ rv_info.level_name }}</span>
            <span class="px-1" v-if="rv_info.fuel_name">/</span>
            <span v-if="rv_info.fuel_name">{{ rv_info.fuel_name }}</span>
            <span class="px-1" v-if="rv_info.transmission_case_type">/</span>
            <span v-if="rv_info.transmission_case_type">{{ rv_info.transmission_case_type }}</span>
            <span class="px-1" v-if="rv_info.year">/</span>
            <span v-if="rv_info.year"> {{ rv_info.year }}年上市</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ArticleService from "../../service/ArticleService";
export default {
  data() {
    return {
      data: {},
      rv_info: null
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getModel(data) {
      if (data.rv_id) {
        ArticleService.getModelInfo({ id: data.rv_id }).then(res => {
          this.rv_info = res.data
        })
      }
    }
  },
  created() {
    ArticleService.getShareInfo(this.$route.query).then((res) => {
      if (res.code == 1 && res.data) {
        this.data = res.data;
        this.getModel(res.data)
      } else {
        this.$alert('抱歉！该临时链接已过期，请联系发布人重新生成！', '已过期', {
          confirmButtonText: '确定',
          callback: action => {
            window.close()
          }
        });
      }
      
    });
  },
};
</script>
<style scoped>
@import "../../css/article.css";
.img-bg {
  font-size: 0;
}

.img-bg:before {
  font-size: 0;
}

table {
  width: 100%;
}

.article-info {
  max-width: 768px;
  box-sizing: border-box;
  margin: 0 auto;
  overflow: hidden;
  background-color: #fff;
  padding: 20px 16px;
  min-height: 100vh;
}

@media (min-width: 540px) {
  .article-info {
    padding-left: 16px;
    padding-right: 16px;
  }
}

@media (min-width: 768px) {
  body {
    background-color: #f8f8f8;
  }
  .article-info {
    padding-left: 64px;
    padding-right: 64px;
  }
}

.article-info .ql-editor {
  padding: 0 0;
}
body .article-info p{
  margin-bottom: 1rem;
}
.article img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
  border-radius: 4px 4px;
  position: relative;
  background-color: #f5f8fa;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 28px 28px;
}

.articlea {
  color: #3598ff;
  text-decoration: none;
}

a:hover {
  color: #31708f;
}

a.unstyled:hover,
a.unstyled:active,
a.unstyled:focus,
a.unstyled:visited {
  color: #000;
}
blockquote {
  border-left: 4px solid #e8f4fd;
  /* background-color: #E8F4FD; */
  font-size: 0.9em;
  color: #505b6c;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}
h1 {
  font-size: 24px;
}

h2 {
  font-size: 18px;
}

p {
  padding: 6px 0;
  text-indent: 0;
  margin: 0 0;
  -webkit-text-size-adjust: none;
}
article {
  font-size: 18px;
  line-height: 1.75;
}

.user-section {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 14px;
  padding: 10px 0;
  color: #222;
}
.user-section:hover,
.user-section:active,
.user-section:visited {
  color: #222;
}

.avatar {
  flex: 0 1 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50% 50%;
  margin-right: 15px;
}

.avatar img {
  width: 100%;
  display: block;
}

.user-section .user-name {
  font-size: 14px;
  font-weight: 600;
  line-height: 1em;
}

.user-section .user-sub {
  font-size: 12px;
  line-height: 1em;
  margin-top: 10px;
  color: #999999;
}

.ql-video {
  width: 100%;
}

.video-link {
  display: block;
  text-align: center;
  background: #333;
}

.video-link > div {
  display: block;
  width: 100%;
  height: 200px;
  background: #333;
  background-repeat: no-repeat;
  background-size: 100%;
  overflow: hidden;
  position: center;
}

.video-link img {
  width: 100%;
}

.img {
  background-color: #f4f4f7;
  display: block;
  border-radius: 6px 6px;
  position: relative;
}

.aspect {
  position: relative;
  height: 0;
  width: 100%;
}

.aspect[data-ratio="16:9"] {
  padding-top: 56.25%;
}

.aspect > * {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.img-bg {
  display: table;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  width: 100%;
  z-index: 0;
}

.img-bg:before {
  text-align: center;
  color: #e8e8e8;
  font-weight: bolder;
  display: table-cell;
  content: "房车家族";
  vertical-align: middle;
}

.text-muted {
  color: #999999;
}

.text-sm {
  font-size: 12px;
}

.text-center {
  text-align: center;
}
.padder-v {
  padding-top: 10px;
  padding-bottom: 10px;
}

.padder-v-sm {
  padding-top: 5px;
  padding-bottom: 5px;
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>